/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} GamesInputs */

const th_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกม`)
};

const en_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games`)
};

const ja_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合`)
};

const zh_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比赛`)
};

const es_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partidos`)
};

const pt_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos`)
};

const id_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertandingan`)
};

const fr_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matchs`)
};

const tl_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga laro`)
};

const vi_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trận đấu`)
};

const ko_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기`)
};

const de_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiele`)
};

const ru_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчи`)
};

const tr_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maçlar`)
};

const it_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partite`)
};

const pl_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mecze`)
};

const uk_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчі`)
};

const hi_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच`)
};

const ar_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المباريات`)
};

const ms_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlawanan`)
};

const bn_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলা`)
};

const zh_tw2_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比賽`)
};

const zh_hk2_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比賽`)
};

const ur_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچ`)
};

const fa_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازی‌ها`)
};

const sw_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michezo`)
};

const nl_games = /** @type {(inputs: GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijden`)
};

/**
* | output |
* | --- |
* | "Games" |
*
* @param {GamesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const games = /** @type {((inputs?: GamesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<GamesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_games(inputs)
	if (locale === "ja") return ja_games(inputs)
	if (locale === "zh") return zh_games(inputs)
	if (locale === "es") return es_games(inputs)
	if (locale === "pt") return pt_games(inputs)
	if (locale === "id") return id_games(inputs)
	if (locale === "fr") return fr_games(inputs)
	if (locale === "tl") return tl_games(inputs)
	if (locale === "vi") return vi_games(inputs)
	if (locale === "ko") return ko_games(inputs)
	if (locale === "de") return de_games(inputs)
	if (locale === "ru") return ru_games(inputs)
	if (locale === "tr") return tr_games(inputs)
	if (locale === "it") return it_games(inputs)
	if (locale === "pl") return pl_games(inputs)
	if (locale === "uk") return uk_games(inputs)
	if (locale === "hi") return hi_games(inputs)
	if (locale === "ar") return ar_games(inputs)
	if (locale === "ms") return ms_games(inputs)
	if (locale === "bn") return bn_games(inputs)
	if (locale === "zh-TW") return zh_tw2_games(inputs)
	if (locale === "zh-HK") return zh_hk2_games(inputs)
	if (locale === "ur") return ur_games(inputs)
	if (locale === "fa") return fa_games(inputs)
	if (locale === "sw") return sw_games(inputs)
	if (locale === "nl") return nl_games(inputs)
	return en_games(inputs)
});